import { memo } from 'react';

import VSpacing from 'bloko/blocks/vSpacing';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import { PriceCartProductType } from 'src/models/price/priceCart';

interface RegionAndProfAreaProps {
    product: PriceCartProductType;
}

const TrlKeys = {
    allProfRoleGroup: 'billing_professional_role_group.0',
};

const RegionAndProfArea: TranslatedComponent<RegionAndProfAreaProps> = ({ product, trls }) => {
    return (
        <>
            <VSpacing base={3} />
            {product.regionTrl && (
                <p>
                    <span data-qa="cart-item__region">{product.regionTrl}</span>
                </p>
            )}
            {product.profRoleGroupTrls
                ? product.profRoleGroupTrls.map((profRoleGroupTrl, index, profRoleGroups) => (
                      <p key={profRoleGroupTrl} data-qa="cart-item__prof-role-group">
                          {profRoleGroupTrl}
                          {index !== profRoleGroups.length - 1 && ';'}
                      </p>
                  ))
                : trls[TrlKeys.allProfRoleGroup]}
        </>
    );
};

export default memo(translation(RegionAndProfArea));
